export const calculateBookingDuration = (booking: {
  starts_at: string
  ends_at: string
}) => {
  const startDate = new Date(booking.starts_at)
  const endDate = new Date(booking.ends_at)

  return (endDate.valueOf() - startDate.valueOf()) / 1000 / 60
}
